import React from 'react';

import styles from './styles.module.scss';

function HorizontalLine() {
  // comment
  return (
    <div className={ styles.Root } />
  );
}

export default HorizontalLine;
